import type { ReactNode } from 'react';
import { Sidebar, type SidebarProps } from './Sidebar';

/** Grade do painel (`.app`): sidebar + conteúdo. */
export function AppShell({ children, ...sidebar }: SidebarProps & { children: ReactNode }) {
  return (
    <div className="app">
      <Sidebar {...sidebar} />
      {children}
    </div>
  );
}
